import React from "react";
import {
    FaFileArchive,
    FaFileAudio,
    FaFileCode,
    FaFileCsv,
    FaFileExcel,
    FaFileImage,
    FaFilePdf,
    FaFilePowerpoint,
    FaFileVideo,
    FaFileWord
} from "react-icons/fa";
import { FiFile, FiFileText } from "react-icons/fi";

const getFileIcon = (type: string, color?: string) => {
    switch (type) {
        case "application/msword":
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
            return <FaFileWord style={{ color: color ?? "#3962FA" }} />;
        case "application/vnd.ms-excel":
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
            return <FaFileExcel style={{ color: color ?? "#10A97A" }} />;
        case "application/pdf":
            return <FaFilePdf style={{ color: color ?? "#FF5B6E" }} />;
        case "application/vnd.ms-powerpoint":
        case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
            return <FaFilePowerpoint style={{ color: color ?? "#FF6A4D" }} />;
        case "text/csv":
            return <FaFileCsv style={{ color: color ?? "#10A97A" }} />;
        case "text/html":
        case "text/css":
        case "text/javascript":
            return <FaFileCode style={{ color: color ?? "#3962FA" }} />;
        case "image/png":
        case "image/jpeg":
        case "image/gif":
        case "image/svg+xml":
            return <FaFileImage style={{ color: color ?? "#42C6B0" }} />;
        case "audio/mpeg":
        case "audio/wav":
            return <FaFileAudio style={{ color: color ?? "#7D6ADB" }} />;
        case "video/mp4":
        case "video/mpeg":
        case "video/quicktime":
            return <FaFileVideo style={{ color: color ?? "#7D6ADB" }} />;
        case "application/zip":
        case "application/x-zip-compressed":
        case "application/x-rar-compressed":
            return <FaFileArchive style={{ color: color ?? "#11B3FF" }} />;
        case "text/plain":
            return <FiFileText style={{ color: color ?? "#42C6B0" }} />;
        default:
            return <FiFile style={{ color: color ?? "#42C6B0" }} />;
    }
};

interface MimeIconProps {
    mimetype: string;
    size?: number;
    color?: string;
}

export default function MimeIcon({
    mimetype,
    size = 40,
    color
}: MimeIconProps) {
    return (
        <div style={{ fontSize: size, lineHeight: 1 }}>
            {getFileIcon(mimetype?.toLocaleLowerCase(), color)}
        </div>
    );
}
